import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatBadge } from '@angular/material/badge'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import {
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneSubtitleComponent,
  ElderValidationErrorDirective,
  ViewProviders,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProcessingTimeVariantTableComponent } from '../../capacities/processing-time-table/processing-time-variant-table.component'
import { ConstraintTableComponent } from '../../constraints/constraint-table/constraint-table.component'
import { SkillSetConf } from '../skill-set-conf'

@Component({
  selector: 'app-skill-set-detail',
  templateUrl: './skill-set-detail.component.html',
  styleUrls: ['./skill-set-detail.component.scss'],
  viewProviders: [ViewProviders.ParentControlContainer],
  imports: [
    ElderPaneComponent,
    ElderPaneHeaderComponent,
    ElderPaneContentComponent,
    ElderPaneSubtitleComponent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatError,
    ElderValidationErrorDirective,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatBadge,
    ConstraintTableComponent,
    ProcessingTimeVariantTableComponent,
    ElderTranslatePipe,
  ],
})
export class SkillSetDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly skillSet = input<SkillSetConf>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}
}
